import { Component, Input, OnInit, inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { MatDialog } from "@angular/material/dialog";
import { TeamStore } from "@app/services/store/team-store";
import { TeamsAddComponent } from "@app/view/setup/resourcing/team/teams-add/teams-add.component";
import { BaseDataTablePageDirective } from "@app/view/shared/base-pages/base-data-table-page/base-data-table-page.directive";
import { SystemSearchMetaRestService } from "@app/services/hal/system-search-meta-rest.service";
import { UntypedFormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { Team } from "@app/models/rest/team";
import { RowExpanderConfig } from "@bryntum/grid-thin";
import { MatToolbar } from "@angular/material/toolbar";
import { MatButton } from "@angular/material/button";
import { GridComponent } from "../../../../shared/base-pages/base-data-table-page/grid.component";
import { MatPaginator } from "@angular/material/paginator";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-teams",
  templateUrl: "./teams.component.html",
  styleUrls: ["./teams.component.scss"],
  imports: [MatToolbar, MatButton, GridComponent, MatPaginator, TranslatePipe]
})
export class TeamsComponent
  extends BaseDataTablePageDirective<Team>
  implements OnInit
{
  teamStore: TeamStore;
  protected store: Store<any>;
  protected dialog: MatDialog;
  protected formBuilder: UntypedFormBuilder;
  protected router = inject(Router);
  serverErrorHandler: ServiceErrorHandlerService;
  protected ngxUiLoaderService: NgxUiLoaderService;

  public rowExpanderConfig: Partial<RowExpanderConfig> = {
    columnPosition: "last",

    renderer: async ({ record }) => {
      return `<team-detail-component team-id="${record.id}" style="width:100%"></team-detail-component>`;
    }
  };

  @Input()
  public columns: object[] = [
    {
      field: "name",
      text: "Name",
      flex: 1,
      editor: true
    }
  ];

  constructor() {
    const systemSearchMetaRestService = inject(SystemSearchMetaRestService);
    const teamStore = inject(TeamStore);
    const store = inject<Store<any>>(Store);
    const dialog = inject(MatDialog);
    const formBuilder = inject(UntypedFormBuilder);
    const serverErrorHandler = inject(ServiceErrorHandlerService);
    const ngxUiLoaderService = inject(NgxUiLoaderService);

    super(
      systemSearchMetaRestService,
      teamStore,
      store,
      dialog,
      "Team",
      formBuilder,
      serverErrorHandler,
      ngxUiLoaderService
    );

    this.teamStore = teamStore;
    this.store = store;
    this.dialog = dialog;
    this.formBuilder = formBuilder;
    this.serverErrorHandler = serverErrorHandler;
    this.ngxUiLoaderService = ngxUiLoaderService;
  }

  public get pristine() {
    return (
      !this.gridStore.changes ||
      (this.gridStore.changes.added.length === 0 &&
        this.gridStore.changes.removed.length === 0 &&
        this.gridStore.changes.modified.length === 0)
    );
  }

  ngOnInit() {
    super.ngOnInit();
    this.gridStore.autoCommit = false;
    this.gridStore.load({});
  }

  addRow() {
    this.gridStore.insert(0, {
      name: ""
    });
  }

  addTeam() {
    const dialogRef = this.dialog.open(TeamsAddComponent);

    dialogRef.afterClosed().subscribe((result) => {
      console.log("The dialog was closed");
      console.log(result);
      this.ngOnInit();
    });
  }
}
